import { render, staticRenderFns } from "./DashUploadMore.vue?vue&type=template&id=01f0eb36"
import script from "./DashUploadMore.vue?vue&type=script&lang=js"
export * from "./DashUploadMore.vue?vue&type=script&lang=js"
import style0 from "./DashUploadMore.vue?vue&type=style&index=0&id=01f0eb36&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports